import { render } from "./Splider.vue?vue&type=template&id=b24b0e7c&scoped=true"
import script from "./Splider.vue?vue&type=script&lang=js"
export * from "./Splider.vue?vue&type=script&lang=js"

import "./Splider.vue?vue&type=style&index=0&id=b24b0e7c&scoped=true&lang=scss"

import exportComponent from "C:\\DevWeb\\verdon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b24b0e7c"]])

export default __exports__